// Photo filenames for Holiday Party 2004
const HOLIDAY_PARTY_2004_PHOTOS = [
  'x0408_51854807656_c.jpg',
  'x04014_51854889658_z.jpg',
  'x04016_51854807626_z.jpg',
  'x04017_51855133074_z.jpg',
  'x04019_51855466055_z.jpg',
  'x04021_51855133044_z.jpg',
  'x04022_51853845007_z.jpg',
  'x04023_51853844987_z.jpg',
  'x04025_51854807676_z.jpg',
  'x04026_51854889598_z.jpg',
];

export default HOLIDAY_PARTY_2004_PHOTOS;
